<div
  class="modal"
  [ngClass]="{ 'modal--background': includeBackground }"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal__margin" [ngClass]="{ 'modal--large': modalType === modalTypes.Large }">
    <div class="modal__container">
      <div class="modal__header" *ngIf="hideHeader === false">
        <span (click)="onCloseClicked($event)" class="modal__close"><i class="far fa-fw fa-times"></i></span>
        <h4>{{ title }}</h4>
      </div>

      <div #contentWrap class="modal__body" [class.no-header]="hideHeader" [class.clear-bg]="!scrollable">
        <ng-content></ng-content>
      </div>

      <div *ngIf="includeOkButton || includeSecondaryCloseButton || includeCloseButton"
        [ngClass]="{ 'modal--scrollable': scrollable }"
        class="modal__footer"
        [ngClass]="{ 'modal__footer--border': showFooterBorder }"
      >
        <!-- TODO: extract buttons to 'slots' and remove button specific inputs -->
        <vm-button *ngIf="includeOkButton && !includeSecondaryCloseButton" (buttonClick)="onOkClicked($event)" [level]="okButtonLevel"
          >{{ okButtonText || 'OK' }}
        </vm-button>

        <vm-button *ngIf="includeSecondaryCloseButton" (buttonClick)="onCloseClicked($event)" [level]="closeButtonLevel"
          >{{ closeButtonText || 'Close' }}
        </vm-button>


        <div class="modal__body__close" *ngIf="includeCloseButton">
          <a (click)="onCloseClicked($event)">
            <i class="fal fa-fw fa-chevron-left prefix-icon back-link-icon"></i>
          </a>
          <a class="Body-Small---Link" (click)="onCloseClicked($event)">{{ closeButtonText }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
